var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiometricVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.185,
    height: 41.58,
    viewBox: "0 0 63.185 41.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Biometric_Verification",
    "data-name": "Biometric Verification",
    transform: "translate(-1520.696 -661.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(1534.323 676.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M42.137,51.782a8.3,8.3,0,0,1-.615,3.143l4.144,1.962a31.942,31.942,0,0,0,7.247-5.105S45.14,44,35.552,44c-.107,0-.21.013-.315.016A7.523,7.523,0,0,1,42.137,51.782Z",
    transform: "translate(-18.192 -44)",
    fill: "#4e7aa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M35.717,44.064a23.726,23.726,0,0,0-9.191,2.931l3.553,1.683A7.288,7.288,0,0,1,35.717,44.064Z",
    transform: "translate(-19.91 -43.987)",
    fill: "#7295b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M45.665,55.087l-4.144-1.962a7.205,7.205,0,0,1-6.284,4.624c.105,0,.208.016.315.016A22.331,22.331,0,0,0,45.665,55.087Z",
    transform: "translate(-18.192 -42.2)",
    fill: "#4e7aa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M30.578,51.287A8.329,8.329,0,0,1,31.17,48.2l-3.553-1.683A31.832,31.832,0,0,0,21,51.287s6.949,6.945,15.807,7.706A7.6,7.6,0,0,1,30.578,51.287Z",
    transform: "translate(-21 -43.504)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M42.752,54.152l-13.16-6.234A8.329,8.329,0,0,0,29,51.009a7.6,7.6,0,0,0,6.229,7.706c.408.035.821.054,1.238.061A7.205,7.205,0,0,0,42.752,54.152Z",
    transform: "translate(-19.422 -43.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M29.494,48.688l13.16,6.234a8.3,8.3,0,0,0,.615-3.143,7.523,7.523,0,0,0-6.9-7.767c-.417.007-.83.026-1.238.061A7.288,7.288,0,0,0,29.494,48.688Z",
    transform: "translate(-19.325 -43.997)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(13.581 1.137)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M3776.43,1825.882H3770.7v5.351",
    transform: "translate(-2249 -1163)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M3770.7,1825.882h5.733v5.351",
    transform: "translate(-2193.549 -1163)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M3776.43,1831.233H3770.7v-5.351",
    transform: "translate(-2249 -1128.771)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M3770.7,1831.233h5.733v-5.351",
    transform: "translate(-2193.549 -1128.771)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiometricVerification);
export default __webpack_public_path__ + "static/media/BiometricVerification.028c49721bfaca9372eb67d6403f3eab.svg";
export { ForwardRef as ReactComponent };